import type { FaireProductEntity } from "../../entity_types/product";

export const p_pehk82d2hf: FaireProductEntity = {
  token: "p_pehk82d2hf",
  type: "product",
  name: "Super Duper Sugar Squisher - JellyFish Sugar DNA",
  brandToken: "b_1785c86e",
  brandName: "Top Trenz Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/d33bd2e8b3dbadab6535a2b744e4f994f28590437927b7003d40011a0566d3d2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5848a390ff2c037446dd0ef572088d68195b2381b813203fbd0de4619a1c4d29.jpeg",
    "https://cdn.faire.com/fastly/5c5973403a0270f7bcc5d8dae14e1000e7dc030d247b8b267df4c3cd4dfe9b8a.jpeg",
    "https://cdn.faire.com/fastly/dd4d437aa5a1a9e826968d9f020a265ae8d4a668830775ff5b5c7d56cb6fe997.jpeg",
    "https://cdn.faire.com/fastly/58c38b22183dac190aab37b0ba3b26965f6a13a47e5afb4c30e69a6da25b1e7e.jpeg",
  ],
  priceDollars: 5,
  description:
    "Introducing the first-ever ORIGINAL Sugar DNA Ball—now in an awesome jellyfish design! This ultimate sensory squisher delivers a triple dose of excitement with a cool-to-the-touch exterior, fun DNA balls inside, and wiggly, stretchy tentacles for endless fidgety fun. Perfect for stress relief and sensory play, this jellyfish squishy is a must-have for anyone who loves unique tactile toys. Available in a 24-piece variety assortment, it's the perfect collectible or desk toy for kids and adults alike!\n\nBonus: FREE display when you order any 48 pieces of Super Duper Sugar Squishers product!\nAges 8+ \n",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:39.127Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
